import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConsultaPaginadaViewModel } from '@models';
import { BaseServiceV2 } from '@servicesv2';
import { ConsultaDocumentosAnexosViewModel, DocumentosAnexosViewModel } from 'models/documentos-anexos/DocumentosAnexosViewModel';

@Injectable()
export class DocumentosAnexosServiceV2 extends BaseServiceV2 {

    constructor(http: HttpClient) {
        super('DocumentosAnexos', http);
    }

    downloadDocumentoAnexo(documentoId: number) {
        return this.downloadBlobAsPromise<any>(null, `downloadDocumentoAnexo/${documentoId}`);
    }

    uploadDocumentosAnexos(vm: DocumentosAnexosViewModel, files: File[]) {
        if (files.length < 1) {
            return;
        }

        const form = new FormData();
        try {
            const vmJson = JSON.stringify(vm);
            form.append('vm', vmJson);
            files.forEach(file => form.append('documentoAnexo', file));
        } catch (e) {
        }

        return this.postAsPromise<any, any>(form, `uploadDocumentosAnexos`)
    }

    consultarModelosColecao(payload: ConsultaDocumentosAnexosViewModel) {
        return this.postPaginatedAsPromise<ConsultaDocumentosAnexosViewModel, ConsultaPaginadaViewModel<DocumentosAnexosViewModel>>(payload, 'buscaDocumentosAnexos');
    }

    consultarDocumentosViaMovimentacaoId(movimentacaoId: number) {
        return this.getAsPromise<DocumentosAnexosViewModel[]>(`buscarDocumentosMovimentacao/${movimentacaoId}`);
    }
}
